export default [
  {
    id: 'Edit Title',
    description: 'Edit your RoundTable title',
    seen: false,
    domID: 'onboarding-edit-roundtable-title',
    classes: [{ 'onboarding-edit-title': true }],
  },
  {
    id: 'Edit RoundTable Settings',
    description:
      'Edit RoundTable Settings like anonymity, assessment points, and guidance questions',
    seen: false,
    domID: 'onboarding-roundtable-settings-bar',
    classes: [
      { 'onboarding-bottom': true },
      { 'onboarding-roundtable-settings-bar': true },
    ],
  },
  // {
  //   id: 'Invite Students',
  //   description: 'Invite students to the RoundTable',
  //   seen: false,
  //   domID: 'onboarding-add-students',
  //   classes: [{ 'onboarding-bottom': true }],
  // },
];



// WEBPACK FOOTER //
// ./src/app/features/onboarding/createRoundtableSteps.js